<script setup>
const debug = ref(false)
</script>
<template>
	<div v-if="debug" class="bg-red-500 text-white text-center">
		DEVELOPMENT PHASE — Avoid scam. Do not attempt to transact. Feature is
		incomplete. Avoid scam.
	</div>
	<div>
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
		<VerificationEmailReminder />
	</div>
	<div v-if="debug" class="bg-red-500 text-white text-center">
		DEVELOPMENT PHASE — Avoid scam. Do not attempt to transact. Feature is
		incomplete. Adobo scam!
	</div>
	<div
		v-if="debug"
		class="bg-red-300 text-white text-center fixed inset-0 pt-2 h-10 w-full animate-fadeBlink rotate-45 z-50 scale-[2.5] px-4 m-auto rounded"
	>
		DO NOT SIGN UP. SOFTWARE DEV. IN PROGRESS (3%)
	</div>
</template>

<style>
@keyframes fadeBlink {
	0%,
	100% {
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
}

.animate-fadeBlink {
	animation: fadeBlink 1.5s infinite;
}
</style>
